import React, { useEffect, useState } from "react";
import Axios from "../../../services/AxiosInstance";
import ReactPaginate from 'react-paginate';
import { useNavigate } from 'react-router-dom';


const UpdatePackageName = (props) => {

    const [updatePackageName, setUpdatePackageName] = useState(props.packageName);
    const Navigate = useNavigate();

    const updatePackageApi = () => {
        console.log(updatePackageName, props.packageId);
        Axios
            .post(`api/bussiness/package-edit-name?package_id=${props.packageId}`, {
                package_name : updatePackageName,
            })
            .then((response) => {
                console.log(response);
                props.setIsPackageNameUpdated(true);
            }).catch((error) => {
                alert(error.response.data.message);
            });
    }
    return (
        <>
            <div className="col-md-6 col-xl-3">
                <div className="card-box">
                    <div className="form-group mb-0 text-center">
                        <div className="form-group mb-3">
                            <label htmlFor="group-name">Package Name</label>
                            <input
                                onChange={(e) => setUpdatePackageName(e.target.value)}
                                id="package-name"
                                value={updatePackageName}
                                type="text"
                                className="form-control"
                                placeholder="Enter Package Name"
                            />
                        </div>
                    </div>
                        <div className="row mt-4">
                            <div className="form-group mb-0 text-center">
                                <button onClick={updatePackageApi} className="btn btn-gradient btn-block" type="submit"> Update Package Name </button>
                                <h2 onClick={() => props.setEditName(false)}>x</h2>
                            </div>
                           
                </div>  </div>
            </div>
        </>
    )
}

export default UpdatePackageName;